var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mc-exercise-frame',[_c('div',{staticClass:"mc-layout-normal-container"},[_c('div',{staticClass:"mc-container"},[_c('output-frames',{attrs:{"output-frames":_vm.outputFrames}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }